import { styled } from '@mui/material/styles';
import { Link as MuiLink } from '@mui/material';
import { AnchorHTMLAttributes, ClassAttributes } from 'react';
import { ExtraProps } from 'react-markdown';
import { VIEW_ARTICLE } from 'constants/routes';

type FormatLinkProps = ClassAttributes<HTMLAnchorElement> &
  AnchorHTMLAttributes<HTMLAnchorElement> &
  ExtraProps & {
    getSourceRefId?: (index: number) => string;
  };

function FormatLink(props: FormatLinkProps) {
  const { children, className, node, getSourceRefId, ...rest } = props;

  if (children === 'source') {
    return (
      <Link
        {...(rest as any)}
        href={VIEW_ARTICLE.replace(
          ':articleId',
          getSourceRefId?.(Number(props.href?.slice(-1)) || 0) || '',
        )}
        target="_blank"
        className={props.className}
        title="Reference"
        visibility="hidden"
      >
        [{props.href?.slice(-1) || 0}]
      </Link>
    );
  }

  return (
    <Link {...(rest as any)} href={props.href} target="_blank" className={props.className}>
      {children}
    </Link>
  );
}

const Link = styled(MuiLink, { label: 'Link' })(({ theme }) => ({
  fontSize: 14,
  fontWeight: 500,
  textDecoration: 'none',
  cursor: 'pointer',
  color: theme.palette.custom.link,
  '&: hover': {
    textDecoration: 'underline',
  },
}));

export default FormatLink;
